/**
 * Cấu hình thông tin liên hệ
 * Dễ dàng thay đổi thông tin liên hệ từ một nơi
 */

export const CONTACT_CONFIG = {
  // Thông tin liên hệ chính
  phone: '+84764774647',
  email: 'support@rentalshop.com',
  zalo: '0764774647',
  
  // URL liên hệ
  phoneUrl: 'tel:+84764774647',
  emailUrl: 'mailto:support@rentalshop.com?subject=Gia hạn dịch vụ',
  zaloUrl: 'https://zalo.me/0764774647',
  
  // Thông tin hỗ trợ
  supportHours: '8:00 - 18:00 (Thứ 2 - Thứ 7)',
  supportEmail: 'trinhduc20@gmail.com',
  
  // Thông tin công ty
  companyName: 'RentalShop',
  website: 'https://rentalshop.org',
  
  // Cấu hình thông báo
  warningDays: 3, // Số ngày cảnh báo trước khi hết hạn
  checkInterval: 60 * 60 * 1000, // Kiểm tra mỗi giờ (ms)
};

/**
 * Hàm tạo URL liên hệ
 */
export const getContactUrls = () => {
  return {
    phone: `tel:${CONTACT_CONFIG.phone}`,
    email: `${CONTACT_CONFIG.emailUrl}`,
    zalo: `https://zalo.me/${CONTACT_CONFIG.zalo}`,
  };
};

/**
 * Hàm mở liên hệ
 */
export const openContact = (type) => {
  const urls = getContactUrls();
  
  switch (type) {
    case 'phone':
      window.open(urls.phone, '_blank');
      break;
    case 'email':
      window.open(urls.email, '_blank');
      break;
    case 'zalo':
      window.open(urls.zalo, '_blank');
      break;
    default:
      console.warn('Unknown contact type:', type);
  }
}; 